import axios from 'axios';

const API_URL = process.env.NEXT_PUBLIC_API_URL || 'http://localhost:8080/api';

export interface LoginRequest {
    email: string;
    password?: string;
    // Campo opcional; o controle principal de "remember me" é feito no login/page.tsx
    rememberMe?: boolean;
}

export interface LoginResponse {
    token: string;
    nome: string;
    email: string;
    role: string;
    id: string;
    concessionariaNome?: string; // Nome da concessionária
    concessionariaId?: string;   // ID da concessionária (para paths no Supabase Storage)
}

export const AuthService = {
    login: async (credentials: LoginRequest): Promise<LoginResponse> => {
        const response = await axios.post(`${API_URL}/auth/login`, credentials);
        return response.data;
    },

    logout: () => {
        if (typeof window !== 'undefined') {
            sessionStorage.removeItem('token');
            sessionStorage.removeItem('user');
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            document.cookie = "token=; path=/; max-age=0";
        }
    },

    getCurrentUser: () => {
        if (typeof window !== 'undefined') {
            const fromSession = sessionStorage.getItem('user');
            if (fromSession) return JSON.parse(fromSession);
            const fromLocal = localStorage.getItem('user');
            if (fromLocal) return JSON.parse(fromLocal);
        }
        return null;
    },

    /** Atualiza dados do usuário no storage (ex.: após atualizar perfil/foto) para refletir na sidebar sem novo login */
    updateCurrentUser: (partial: Record<string, unknown>) => {
        if (typeof window === 'undefined') return;
        const current = AuthService.getCurrentUser();
        if (!current) return;
        const updated = { ...current, ...partial };
        const str = JSON.stringify(updated);
        if (sessionStorage.getItem('user')) sessionStorage.setItem('user', str);
        if (localStorage.getItem('user')) localStorage.setItem('user', str);
        window.dispatchEvent(new CustomEvent('user-updated'));
    },
};
